import React from "react";
import {Link} from 'react-router-dom';
import BlogCard from "../component/BlogCard";

const Blog = () => {
    return (
        <main className="main">
            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">সংবাদ ও ব্লগ </h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link className="nav-link" to={"/"}>হোম</Link>
                        </li>
                        <li className="active">সংবাদ ও ব্লগ </li>
                    </ul>
                </div>
            </div>

            <BlogCard />

        </main>
    );
}

export default Blog;